import React, { useContext } from "react";
import { FormContext } from '../../Pages/Apply'
import ApplicantProfile from './ApplicantProfile'
import EligibilityCheck from './EligibilityCheck'
import UploadDocuments from './UploadDocuments'
import Success from './Success'

const  Step = (props) => {
  const { activeStepIndex } = useContext(FormContext);
  let stepContent;
  switch (activeStepIndex) {
    case 0:
      stepContent = <ApplicantProfile />;
      break;
    case 1:
      stepContent = <EligibilityCheck />;
      break;
    case 2:
      stepContent = <UploadDocuments />;
      break;
      case 3:
        stepContent = <Success />;
        break;
  
    default:
      break;
  }

  return stepContent;
}

export default Step;